  <template>
  <transition name="fade" mode="out-in" appear>
    <div class="card text-center">
      <div class="card-header">
        <h5 class="card-title">{{ piece.title }}</h5>
     </div>
     <template v-if="!piece.vidId">
      <div class="card-body">
        <!-- <router-link :piece = 'piece' :to="pickLink + piece.id"> -->
        <router-link :piece = 'piece' :to="'/piece/' + piece.id">
          <img :src= piece.imageUrl />
          <!-- <img v-else :src= piece.image /> -->
        </router-link>
        <p class="card-text">{{ piece.previewText }}</p>
      </div>
     </template>
    <template v-else>
      <div class="card-body">
                <router-link :piece = 'piece' :to="'/piece/' + piece.id">
          <img  :src="`https://img.youtube.com/vi/${piece.vidId}/hqdefault.jpg`" />
        </router-link>
        <p class="card-text">{{ piece.previewText }}</p>

      </div>
    </template>

      <div class="card-footer">

         <router-link :to="'/piece/' + piece.id" v-if="piece.vidId"><button class="custom-button">Watch Video</button></router-link>
         <router-link :to="'/piece/' + piece.id" v-else><button class="custom-button">View Piece</button></router-link>
      </div>
  </div>
    </transition>
</template>

<script>
export default {
  data() {
    return {
      link: '',
    }
  },
  props: ['piece'],
  // computed: {
  //   pickLink() {
  //       return this.link= '/piece/'
  //   }
  // }
}
</script>

